<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <!-- <template #start>
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template> -->
      <template #end>
        <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
          <i v-if="!btnloading" class="el-icon-folder"></i>
          导出
        </el-button>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight2" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      formInline: {
        ischeck: 1,
        isstatus: 4,
      },
      btns: [
        {
          title: '出车费用表',
          //img: require('@/assets/img/icon_operate_05.png'),
          img: require('@/assets/img/icon_operate_055.png'),
          unimg: require('@/assets/img/icon_operate_055_hover.png'),
          cb: ({ id, isstatus }) => {
            let mode = 'view'
            const { user_group_id } = this.user
            if (isstatus == 4 && user_group_id == 1 && this.user.id == 1) {
              mode = 'edit'
            }
            this.$router.push(
              `/contract/orderFeeDetail?id=${id}&mode=${mode}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderdetail?id=${id}&mode=edit`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>
